// src/data/dataConfig.js

export const dataConfig = {
    academicYears: [
      {
        id: "2024-2025",
        label: "Año Escolar 2024–2025",
        path: "archive/2024-2025",
        isArchived: true,
        momentos: [1, 2, 3],
      },
      {
        id: "2025-2026",
        label: "Año Escolar 2025–2026",
        path: "current/2025-2026",
        isArchived: false,
        momentos: [1, 2, 3],
      },
    ],
  
    defaultYear: "2025-2026",
    defaultMomento: "2",
  };
  
  /**
   * Helpers
   */
  export const getYearConfig = (yearId) => {
    return dataConfig.academicYears.find((y) => y.id === yearId);
  };
  
  export const isMomentoAvailable = (yearId, momento) => {
    const year = getYearConfig(yearId);
    if (!year) return false;
    return year.momentos.includes(Number(momento));
  };
  